import { z } from "zod"

import { standardStringSchema } from "./string.schema"

export const isoDateSchema = standardStringSchema.min(1).pipe(z.iso.date())
